export class AuthHeaderProvider {

	authHeader(): string {
		return null;
	}

	authHeaderValue(): string {
		return null;
	}
}